export default function hasNoFlexibleColumns(widthsMeta) {
  return widthsMeta.totalFlexibleColumns === 0;
}